import { render, staticRenderFns } from "./LoyaltyManage.vue?vue&type=template&id=2468f360&"
import script from "./LoyaltyManage.vue?vue&type=script&lang=js&"
export * from "./LoyaltyManage.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports